/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_WorkspaceInputs */

const en_cc_workspace = /** @type {(inputs: Cc_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active workspace`)
};

const id_cc_workspace = /** @type {(inputs: Cc_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace aktif`)
};

/**
* | output |
* | --- |
* | "Active workspace" |
*
* @param {Cc_WorkspaceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_workspace = /** @type {((inputs?: Cc_WorkspaceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_WorkspaceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_workspace(inputs)
	return en_cc_workspace(inputs)
});